/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Tlm_0Inputs */

const en_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voice_stack`)
};

const ar_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البنية الصوتية`)
};

const bn_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভয়েস স্ট্যাক`)
};

const de_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice-Stack`)
};

const es_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack de voz`)
};

const fr_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack vocale`)
};

const pt_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack de voz`)
};

const zh_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语音技术栈`)
};

const tr_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ses altyapısı`)
};

const ru_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Голосовой стек`)
};

const pl_svc_ai_voice_agents_tlm_0 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stos głosowy`)
};

/**
* | output |
* | --- |
* | "voice_stack" |
*
* @param {Svc_Ai_Voice_Agents_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_tlm_0 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_tlm_0(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_tlm_0(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_tlm_0(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_tlm_0(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_tlm_0(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_tlm_0(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_tlm_0(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_tlm_0(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_tlm_0(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_tlm_0(inputs)
	return en_svc_ai_voice_agents_tlm_0(inputs)
});
export { svc_ai_voice_agents_tlm_0 as "svc_ai-voice-agents_tlm_0" }